import React, { Dispatch, memo, useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

import MultiSelectWithModalBase, {
	MultiSelectWithModal,
} from "../MultiSelectWithModal";

const MultiSelectOrderClassesWithModalBase: React.FC<
	MultiSelectOrderClassesWithModalBase.Props
> = ({
	value,
	onChange,
	disabled,
	titleText,
	allText,
	allActiveText,
	required,
	modalSetting,
	selectOptions = [],
	sort,
	...props
}) => {
	const { t } = useTranslation();
	const [error, setError] = useState("");

	const memoizedOptions = useMemo(() => selectOptions, [selectOptions]);

	const selected = useMemo<MultiSelectWithModalBase.Value>(
		() =>
			memoizedOptions.filter((item) => {
				const retval = value.find((key) => key === item.key);
				return typeof retval === "number";
			}),
		[memoizedOptions, value],
	);

	const selectOnChange = useCallback(
		(newValue: { value: number }[]) => {
			setError("");
			const Ids = newValue.map((item) => item.value);
			onChange(Ids);
		},
		[onChange],
	);

	const texts = useMemo(
		() => ({
			title: t(titleText),
			allText: t(allText),
			allActiveText: t(allActiveText),
		}),
		[allActiveText, allText, t, titleText],
	);

	const memoizedModalSetting = useMemo(() => modalSetting, [modalSetting]);
	const memoizedSort = useMemo(
		() =>
			sort
				? {
						show: true,
						active: true,
						...sort,
				  }
				: undefined,
		[sort],
	);

	return (
		<MultiSelectWithModal
			error={error}
			disabled={disabled}
			value={selected}
			title={texts.title}
			allText={texts.allText}
			allActiveText={texts.allActiveText}
			options={memoizedOptions}
			onChange={selectOnChange}
			required={required}
			pullUpItemInsideArray
			hiddenButton={false}
			showSelectAll
			modalSetting={memoizedModalSetting}
			sort={memoizedSort}
			{...props}
		/>
	);
};

// export const MultiSelectOrderClassesWithModal = memo(
// 	MultiSelectOrderClassesWithModalBase,
// );

declare namespace MultiSelectOrderClassesWithModalBase {
	interface Props extends MultiSelectWithModalBase.Setting {
		value: Value;
		onChange: Dispatch<Value>;
		titleText: string | string[];
		allText: string | string[];
		allActiveText: string | string[];
		modalSetting?: MultiSelectWithModalBase.ListSelectProps["modalSetting"];
		selectOptions: MultiSelectWithModalBase.Value;
		sort?: {
			show?: boolean;
			active?: boolean;
			[key: string]: any;
		};
	}

	type Value = number[];
}

export default MultiSelectOrderClassesWithModalBase;
